import React, { useState } from "react";
import { SwitcherButton, SwitcherContainer } from "./salary.styled";
import { useTranslation } from "react-i18next";

export type ViewMode = "xml" | "list";

interface ViewModeSwitcherProps {
  onChange?: (mode: ViewMode) => void;
  defaultMode?: ViewMode;
}

export const ViewModeSwitcher: React.FC<ViewModeSwitcherProps> = ({
  onChange,
  defaultMode = "list",
}) => {
  const [viewMode, setViewMode] = useState<ViewMode>(defaultMode);
  const { t } = useTranslation();

  const handleToggle = (mode: ViewMode) => {
    setViewMode(mode);
    if (onChange) {
      onChange(mode);
    }
  };

  return (
    <SwitcherContainer>
      <SwitcherButton
        $active={viewMode === "xml"}
        onClick={() => handleToggle("xml")}
        aria-pressed={viewMode === "xml"}
      >
        {t("Salary.XML")}
      </SwitcherButton>
      <SwitcherButton
        $active={viewMode === "list"}
        onClick={() => handleToggle("list")}
        aria-pressed={viewMode === "list"}
      >
        {t("Salary.List")}
      </SwitcherButton>
    </SwitcherContainer>
  );
};
